import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

import {TranslateService} from "@ngx-translate/core";

import {LinkViewModel} from "@data-sharing/view-models/link-view-model";
import {DataSharingHttpService} from "@data-sharing/http-services/data-sharing-http.service";

@Component({
  selector: 'dsm-confirm-links-removal-modal',
  templateUrl: './confirm-links-removal-modal.component.html',
})
export class ConfirmLinksRemovalModalComponent implements OnInit {

  isLoading = false;
  questionTrans = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public models: LinkViewModel[],
    private matDialogRef: MatDialogRef<ConfirmLinksRemovalModalComponent>,
    private dataSharingHttpService: DataSharingHttpService,
    private translateService: TranslateService
  ) {
    this.translateService.get('data-sharing.remove-links-question', {count: this.models.length})
      .subscribe(t => this.questionTrans = t);
  }

  ngOnInit(): void {
  }

  onClose() {
    if (!this.isLoading)
      this.matDialogRef.close(false);
  }

  onRemove() {
    this.isLoading = true;

    this.dataSharingHttpService.delete(this.models.map(x => x.link.id)).subscribe(() => {
      this.isLoading = false;
      this.matDialogRef.close(true);
    });
  }

}
